import React, { useContext, useMemo } from 'react';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { formatPrice } from '../../utils/price.js';
import { getProductNewPrice, getProductOldPrice, getProductImage } from '../../utils/cart.js';
import { formatProductName, extractVariantsFromProductName } from '../../utils/product.js';
import Button from '../Button/index.js';
import ButtonGroup from '../ButtonGroup/index.js';
import Modal from '../Modal/index.js';
import { S as SHOPPING_CART, k as CHECKOUT } from '../../paths-ZKN3m62_.js';
import { CoreContext } from '../../context/index.js';
import '../../utils/logToSlack.js';
import '../../animations--PMkOS0j.js';
import 'cookies-next';
import '../../currency-_kacFJHO.js';
import '../../language-BHHwgtQp.js';
import '../../payment-a4IKjS7g.js';
import '../../index-dEXHnASi.js';
import 'notistack';
import useWindowSize from '../../hooks/useWindowSize.js';
import '../../helpers-WYINLSKJ.js';
import 'lodash';
import { toggleModal } from '../../store/modal/index.js';
import '../../types/index.js';
import '../../checkout-Ee1eEXQH.js';
import '../../menu-0TyOg98i.js';
import '../../product-_pRduMz7.js';
import { M as ModalType } from '../../modal-6vnX5SO3.js';
import 'number-currency-format';
import 'lodash/get';
import '../../utils/currency.js';
import '../../MergeCarts-sPldCtIn.js';
import '../../ProcessReactivateCart-uQs33rRl.js';
import '../../requestsCollection-A0HzS4ai.js';
import 'graphql-request';
import 'lodash/cloneDeep';
import '../../services/auth/index.js';
import '../../utils/cookies.js';
import '../../cookies-VX_DpI1q.js';
import '../../utils/isBot.js';
import '../../utils/fetchPolicyLookup.js';
import '../../cart-AU0vdOfm.js';
import '../../serverErrors-O6unZmFR.js';
import '../../utils/error.js';
import '../../utils/logger.js';
import '../../utils/logToRelic.js';
import '../../index-2586sEvh.js';
import '../../_commonjsHelpers-jjO7Zipk.js';
import '../CircularProgress/index.js';
import '../Link/index.js';
import 'next/link';
import '../OnlyUIRender/index.js';
import '../Modal/ModalContent/index.js';
import 'react-dom';
import '../../hooks/useAutoFocus.js';
import '../../hooks/useGetPortalRoot.js';
import '../../utils/portalRoot.js';
import '../FocusTrap/index.js';
import '../IconButton/index.js';
import '../Modal/ModalHeader/index.js';
import '../../index-RkBJ48Nr.js';
import 'i18next';
import 'react-i18next';
import '../../index-itNs9E93.js';
import '@reduxjs/toolkit';
import '../../store/modal/initialState.js';

const JustAddedProducts = ({ data, onClose }) => {
    const { t } = useTranslation('', { keyPrefix: '' });
    const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });
    const { t: tLabel } = useTranslation('', { keyPrefix: '$common.$labels' });
    const { t: tHeading } = useTranslation('', { keyPrefix: '$common.$headings' });
    const { data: { siteConfig: { cart: { useCartDrawer = false } = {}, noZeroAfterDecimal = false }, }, useDispatch, } = useContext(CoreContext);
    const dispatch = useDispatch();
    const router = useRouter();
    const discounts = data.prices.discounts || [];
    const discountPriceValue = useMemo(
    // do not include "Free-shipping discount"
    () => discounts
        .filter(item => !item.is_free_shipping)
        .reduce((acc, val) => acc + val.amount.value, 0), [discounts]);
    const subTotalExcludingTax = data.prices.subtotal_including_tax;
    const currencyCode = subTotalExcludingTax.currency;
    const locale = router.locale;
    const discountPriceText = formatPrice(discountPriceValue, currencyCode, locale, noZeroAfterDecimal, true);
    const subTotalText = formatPrice(subTotalExcludingTax.value, subTotalExcludingTax.currency, locale, noZeroAfterDecimal);
    const windowSize = useWindowSize();
    const isMobile = windowSize.width < 768;
    const onToCart = (e) => {
        if (useCartDrawer) {
            e.preventDefault();
            onClose();
            dispatch(toggleModal(ModalType.ShoppingCart));
        }
    };
    return (React.createElement(Modal, { maxWidth: "sm", open: true, className: "base-just-added-products-modal", title: tHeading('addSuccessHeading'), onClose: onClose, footer: React.createElement(React.Fragment, null,
            React.createElement("div", { className: "just-added-products-total" },
                React.createElement("div", { className: "total-items" }, data.total_quantity > 1
                    ? `${data.total_quantity} ${t('$common.$labels.items')}`
                    : `${data.total_quantity} ${t('$common.$labels.item')}`),
                React.createElement("ul", { className: "just-added-prices" },
                    React.createElement("li", { className: "just-added-subtotal" },
                        tLabel('subTotal'),
                        ":\u00A0",
                        React.createElement("span", null, subTotalText)),
                    Boolean(discountPriceValue) && (React.createElement("li", { className: "just-added-discount" },
                        tLabel('discount'),
                        ":\u00A0",
                        React.createElement("span", null, discountPriceText))))),
            React.createElement(ButtonGroup, null, !isMobile ? (React.createElement(React.Fragment, null,
                React.createElement(Button, { href: `/${locale}${SHOPPING_CART}`, onClick: onToCart, className: "btn-cart", variant: "plain" }, tButton('toCart')),
                React.createElement(Button, { href: `/${locale}${CHECKOUT}`, className: "btn-checkout" }, tButton('toCheckout')))) : (React.createElement(React.Fragment, null,
                React.createElement(Button, { href: `/${locale}${CHECKOUT}`, className: "btn-checkout" }, tButton('toCheckout')),
                React.createElement(Button, { href: `/${locale}${SHOPPING_CART}`, onClick: onToCart, className: "btn-cart", variant: "plain" }, tButton('toCart')))))) },
        React.createElement("div", { "data-testid": "cart", className: "just-added-products" },
            React.createElement("div", { className: "just-added-products-wrapper" },
                React.createElement("div", { className: "just-added-products-list" }, data.item_selected.map(item => {
                    // eslint-disable-next-line @typescript-eslint/naming-convention
                    const { product, configured_variant } = item;
                    const newPrice = getProductNewPrice(item, currencyCode, locale, noZeroAfterDecimal);
                    const oldPrice = getProductOldPrice(item, currencyCode, locale, noZeroAfterDecimal);
                    const image = getProductImage(item);
                    const productName = formatProductName({
                        name: product.name,
                        lang: locale,
                    });
                    const productVariants = () => {
                        const variants = extractVariantsFromProductName({ name: configured_variant === null || configured_variant === void 0 ? void 0 : configured_variant.name });
                        if (!variants) {
                            return null;
                        }
                        const variantsArray = variants.split(';');
                        return variantsArray.map(variant => (React.createElement("div", { className: "product-variant", key: variant, "data-product-variant-type": "simple" }, variant)));
                    };
                    return (React.createElement("div", { key: item.id, className: "just-added-products-item" },
                        React.createElement("div", { className: "just-added-products-image-wrapper" },
                            React.createElement("div", { className: "just-added-products-image", style: { backgroundImage: `url(${image === null || image === void 0 ? void 0 : image.url})` } })),
                        React.createElement("div", { className: "just-added-products-details" },
                            React.createElement("h3", { className: "just-added-products-name" }, productName),
                            productVariants(),
                            React.createElement("div", { className: "product-prices" },
                                oldPrice && oldPrice !== newPrice && (React.createElement(React.Fragment, null,
                                    React.createElement("span", { "aria-hidden": "false", className: "sr-only" }, t('$common.$labels.originalPrice')),
                                    React.createElement("div", { className: "product-price old strike" }, oldPrice),
                                    React.createElement("span", { "aria-hidden": "false", className: "sr-only" }, t('$common.$labels.price')))),
                                newPrice && React.createElement("div", { className: "product-price" }, newPrice)),
                            React.createElement("div", { className: "quantity" },
                                tLabel('quantity'),
                                ": ",
                                item.just_added_qty))));
                }))))));
};

export { JustAddedProducts as default };
//# sourceMappingURL=index.js.map
